import { LiveStatus, WebinarStatus } from '@core/types';
import { PresenterStatus, setLiveStatus, startWebinar, useAppDispatch, useAppSelector } from '@online-webinar/store';
import { useEffect, useState } from 'react';
import { Popup } from '../../atoms';

export const WebinarCountdownPopup = () => {
    const [countdownTimer, setCountdownTimer] = useState(5);
    const dispatch = useAppDispatch();
    const presenterStatus = useAppSelector((state) => state.liveWebinar.presenterStatus);
    const webinarStatus = useAppSelector((state) => state.liveWebinar.webinarData.status);

    // Start the countdown when we transition to "Countdown" status
    useEffect(() => {
        if (presenterStatus !== PresenterStatus.Countdown) {
            return;
        }

        let i = 5;
        setCountdownTimer(i);
        const interval = setInterval(() => {
            i--;
            setCountdownTimer(i);
            if (i === 0) {
                // The source no longer has to be announced here: the server derives whether this is an
                // external encoder from the ingest type it already has, instead of a flag that was lost
                // whenever the grain went idle.
                if (webinarStatus !== WebinarStatus.Started) {
                    dispatch(startWebinar());
                } else {
                    dispatch(setLiveStatus(LiveStatus.Live));
                }
                clearInterval(interval);
            }
        }, 1000);
        return () => clearInterval(interval);
    }, [presenterStatus, webinarStatus]);

    return (
        <Popup title="Get ready!" open={true} onClose={() => {}} onConfirm={() => {}} isCloseFunctionality={false}>
            <div className="mx-auto relative">
                <div className="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-52 w-52" />
                <div className="absolute left-0 right-0 top-0 bottom-0 text-center flex justify-center items-center flex-col">
                    <div className="text-8xl font-light">{countdownTimer}</div>
                </div>
            </div>
        </Popup>
    );
};
